import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import Wysiwyg from "../../components/Wysiwyg/Wysiwyg";
import ToolbarBase from "../../components/Wysiwyg/toolbar/ToolbarBase";

const headerStyle = {marginBottom: "0.5rem", fontWeight: 500, lineHeight: 1.2, fontSize: "1.25rem"};
const EditorBlog  = props => {

  const {
    formTartalom,
    setFormTartalom,
    showModalTartalom,
    toggleShowModalTartalom,
    listImages,
    addImage
  } = props;

  const EditorHeader = (props) => {
    const {
      toggleShowModalTartalom,
    } = props;
  
    return (
      <React.Fragment>
        <a style={headerStyle}>
          Bejegyzés tartalma
        </a>
        <Button type="button" color="secondary" className="pull-right" style={{border: 'none'}} onClick={() => toggleShowModalTartalom(false)}>
           <i className="fa fa-times" aria-hidden="true" ></i>
        </Button>
      </React.Fragment>
    );
  }

  return (
    <Modal isOpen={showModalTartalom} toggle={() => toggleShowModalTartalom()} backdrop="static" size="lg">
      <ModalHeader 
        tag={() => EditorHeader({toggleShowModalTartalom: toggleShowModalTartalom})}>
      </ModalHeader>
      <ModalBody>
        <div className="row">
          <div className="col-md-12">
            <Wysiwyg value={formTartalom} onChange={setFormTartalom} toolbar={() => <ToolbarBase />} onImageUpload={addImage}/>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          type="button"
          className="btn-cursor-pointer"
          color="primary"
          onClick={() => toggleShowModalTartalom(false)}
        >
          Mentés
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default EditorBlog;